
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClubInfo"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getClubInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameShort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isBraintreePaypalMethodExist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isBraintreeCreditCardMethodExist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maskedNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appPages"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showInNav"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requiresLogin"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canCeckIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canRegister"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLivescoring"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canRPR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canPaypal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLastschrift"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLastschriftRPR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLastschriftTeetime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLastschriftIndoor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLastschriftPro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLastschriftRange"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLastschriftTrackman"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLastschriftWellness"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLastschriftRegisterCourse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canLastschriftRegisterTournament"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logoHeader"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"googleTagID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showInfoScreenPopup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paypalClientID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"askTeetimeNumHoles"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canMeteorPayment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MeteorPaymentTypes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MeteorScriptLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canNFCWallet"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1002}};
    doc.loc.source = {"body":"query getClubInfo {\n    getClubInfo {\n        name\n        nameShort\n        logo\n        isBraintreePaypalMethodExist\n        isBraintreeCreditCardMethodExist\n        maskedNumber\n        expirationDate\n        appPages {\n            title\n            url\n            icon\n            showInNav\n            requiresLogin\n        }\n        latitude\n        longitude\n        canCeckIn\n        canRegister\n        canLivescoring\n        canRPR\n        canPaypal\n        canLastschrift\n        canLastschriftRPR\n        canLastschriftTeetime\n        canLastschriftIndoor\n        canLastschriftPro\n        canLastschriftRange\n        canLastschriftTrackman\n        canLastschriftWellness\n        canLastschriftRegisterCourse\n        canLastschriftRegisterTournament\n        currency\n        logoHeader\n        googleTagID\n        showInfoScreenPopup\n        paypalClientID\n        askTeetimeNumHoles\n        canMeteorPayment\n        MeteorPaymentTypes\n        MeteorScriptLink\n        canNFCWallet\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getClubInfo"] = oneQuery(doc, "getClubInfo");
        
